/*
Author: Liubo
Date: 2018-09-05
Desc: 框架配置文件
*/
const conf = {
    name: "JTUP framework",
    sysname: "",
    systemtype: "2", //系统类型 0:柜台, 2:网上交易, 3:传真, 4:手机, 5: 微信
    api: {
        // axios AJAX 请求时的路径前缀
        baseUrl: process.env.NODE_ENV === "production" ? "/agate/api/v1" : "/api/v1",
        // 银行页面链接地址配置
        bankUrl: "/agate/org"
    },
    session_mode: "1", // 1:agate模式，通过token和key控制会话; 2:传统JROS模式, 前端不做特殊处理，由浏览器session 机制和服务端来控制会话
    encKey: "testkey", // 加密因子。仅用于session_mode 为2的情况。如果session_mode 为1，会取服务端返回的会话信息中的key作为加密因子
    encIV: "0102020303040506", // 加密向量
    projectType: "1", // 项目类型0直销，1代销
    hideFunc: false, // 控制是否隐藏/屏蔽功能  true-不隐藏  false-隐藏（屏蔽开户/交易类操作）
    const: {
        TTY_CHANLEID: "6000", // 天天盈网点号
        CARD_DATE_MAX: "99991231", // 证件号有效期最大值
        BIRTH_DATE: "19000101", // 出生日期最小值
        PAGE_SIZE: "10", // 分页数
        ZX_CENTER: "1000", // 直销中心渠道号
        CUST: ["1.公司的受益所有人应当按照以下标准依次判定：直接或者间接拥有超过25%公司股权或者表决权的自然人；通过人事、财务等其他方式对公司进行控制的自然人；公司的高级管理人员。",
            "2.合伙企业的受益所有人是指拥有超过25%合伙权益的自然人。",
            "3.信托的受益所有人是指信托的委托人、受托人、受益人以及其他对信托实施最终有效控制的自然人。",
            "4.基金的受益所有人是指拥有超过25%权益份额或者其他对基金进行控制的自然人。",
            "*若存在多个受益人信息，请进入账户中心-受益人进行添加。"], // 直销中心渠道号
        INSTREPR: ["法定代表人指依法律或法人章程规定代表法人行使职权的负责人。我国法律实行单一法定代表人制，一般认为法人的正职行政负责人为其惟一法定代表人。如公司为董事长或执行董事或经理，而证券交易所的法定代表人为总经理。全民所有制工业企业的法定代表人为厂长或经理。"],
        CONTROLER: ["股东或控制人，是指其出资额占有限责任公司资本总额百分之五十以上或者其持有的股份占股份有限公司股本总额百分之五十以上的股东；出资额或者持有股份的比例虽然不足百分之五十，但依其出资额或者持有的股份所享有的表决权已足以对股东会、股东大会的决议产生重大影响的股东。"]
    },
    //模块对应模块编号
    modulecode: {
        FCSY: "M01",	//分词索引
        PHB: "M02",	//排行榜
        PTXJB: "M03",	//普通T+0
        QCXJB: "M04",	///全程T+0
        ZNDT: "M05",	//智能定投
        GZLC: "M06",	//工资理财
        ZHTZ: "M07",	//组合投资
        SHZSG: "M08",	//赎回转申购
        HK: "M09", //汇款买基金
        DX: "M10", //整合代销数据
        GDLC: "M11",	//高端理财
        CRS: "M12",	//crs税收
        OCR: "M13",	//OCR识别
        QQWXDL: "M14",	//QQ/微信登录
        WXMB: "M15",	//微信模板   消息
        TJFX: "M16",	//统计分析
        YYSH: "M17",	//预约赎回
        DQLC: "M18",	//短期理财
        SMDL: "M19"	//APP扫码登录
    },
    cache: [
        {
            code: "_session",
            api: "/common/session",
            method: "GET",
            load: true
        },
        {
            code: "_dict",
            api: "/common/dictionary",
            method: "GET",
            load: true
        },
        {
            code: "_params",
            api: "/common/params",
            params: {terminaltype: "0"},
            method: "GET",
            load: true
        },
        {
            code: "_advertise",
            api: "/common/advertinfo",
            method: "GET",
            load: true
        },
        {
            code: "_notice",
            api: "/common/warmnotice",
            method: "GET",
            load: true
        },
        {
            code: "_modulestatus",
            api: "/jump/charge/module/status",
            method: "GET",
            load: true
        },
        {
            code: "_user",
            api: "/acct/orgcust/profile",
            method: "GET"
        }
    ]
};
export default conf;
